import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=a9338146&scoped=true&"
import script from "./Other.vue?vue&type=script&lang=javascript&"
export * from "./Other.vue?vue&type=script&lang=javascript&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9338146",
  null
  
)

export default component.exports